import { Reducer } from 'react';

import { InitialStateType } from '@/modules/payment/subscription/context/context';
import { IGeneral } from '@/shared/types';

export enum subscriptionActionsTypes {
  setPlanId = 'SET_PLAN_ID',
  setIntervalType = 'SET_INTERVAL_TYPE',
}

type subscriptionPayload = {
  [subscriptionActionsTypes.setPlanId]: InitialStateType['planId'];
  [subscriptionActionsTypes.setIntervalType]: InitialStateType['intervalType'];
};

export type Actions =
  IGeneral.ActionMap<subscriptionPayload>[keyof IGeneral.ActionMap<subscriptionPayload>];

export const subscriptionReducer: Reducer<InitialStateType, Actions> = (
  state: InitialStateType,
  action: Actions
) => {
  switch (action.type) {
    case subscriptionActionsTypes.setPlanId:
      return {
        ...state,
        planId: action.payload,
      };
    case subscriptionActionsTypes.setIntervalType:
      return {
        ...state,
        intervalType: action.payload,
      };
    default:
      return state;
  }
};
